import { render, staticRenderFns } from "./StyleableLayout.vue?vue&type=template&id=8f504d6e&scoped=true&"
import script from "./StyleableLayout.vue?vue&type=script&lang=ts&"
export * from "./StyleableLayout.vue?vue&type=script&lang=ts&"
import style0 from "./StyleableLayout.vue?vue&type=style&index=0&id=8f504d6e&prod&scoped=true&lang=scss&"
import style1 from "./StyleableLayout.vue?vue&type=style&index=1&id=8f504d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f504d6e",
  null
  
)

export default component.exports